import axios from 'axios';

class RoamingEmpowermentV2Service {
    sendEmpowermentV2(params) {
        return axios.post('roaming/empowerment-v2/send', params)
    }

    draftEmpowermentV2(empowermentV2) {
        return axios.post("/roaming/empowerment-v2/draft/save", {
            content: empowermentV2
        })
    }

    getAcceptHashCode(id) {
        return axios.get(`/roaming/empowerment-v2/hashcode/accept/${id}`)
    }
    getCancelHashCode(id) {
        return axios.get(`/roaming/empowerment-v2/hashcode/cancel/${id}`,{
            transformResponse: [data => data]
        })
    }
    getDeclineHashCode(id, comment) {
        return axios.get(`/roaming/empowerment-v2/hashcode/decline/${id}`,{
            transformResponse: [data => data],
            params: {comment: comment}
        })
    }

    customerCancelEmpowermentV2({id, signature}) {
        return axios.post(`roaming/empowerment-v2/cancel/${id}`, {
            signature: signature
        })

    }
    personAcceptEmpowermentV2({id, signature}) {
        return axios.post(`roaming/empowerment-v2/person/accept/${id}`, {
            signature
        })
    }
    personDeclineEmpowermentV2({id, signature, comment}) {
        return axios.post(`roaming/empowerment-v2/person/decline/${id}`, {
            signature,
            comment
        })
    }
    executorAcceptEmpowermentV2({id, signature}) {
        return axios.post(`roaming/empowerment-v2/executor/accept/${id}`, {
            signature
        })
    }
    executorDeclineEmpowermentV2({id, signature, comment}) {
        return axios.post(`roaming/empowerment-v2/executor/decline/${id}`, {
            signature,
            comment
        })
    }

    syncEmpowermentV2(id) {
        return axios.get(`roaming/empowerment-v2/sync/${id}`)
    }
    getEmpowermentV2(id) {
        return axios.get(`roaming/empowerment-v2/get/${id}`)
    }

    getEmpowermentV2Draft(id) {
        return axios.get(`/roaming/empowerment-v2/draft/get/${id}`)
    }

    getCustomerEmpowermentsV2(params) {
        return axios.get('roaming/empowerment-v2/customer/get', {
            params
        })
    }
    getCustomerCountEmpowermentsV2(params) {
        return axios.get('roaming/empowerment-v2/customer/count', {
            params
        })
    }
    getPersonEmpowermentsV2(params) {
        return axios.get('roaming/empowerment-v2/person/get', {
            params
        })
    }
    getPersonCountEmpowermentsV2(params) {
        return axios.get('roaming/empowerment-v2/person/count', {
            params
        })
    }

    getExecutorCountDraftEmpowermentsV2(params) {
        return axios.get('/roaming/empowerment-v2/drafts/count', {
            params
        })
    }

    getExecutorEmpowermentsV2(params) {
        return axios.get('roaming/empowerment-v2/executor/get', {
            params
        })
    }

    getExecutorDraftEmpowermentsV2(params) {
        return axios.get('/roaming/empowerment-v2/drafts/get', {
            params
        })
    }

    getExecutorCountEmpowermentsV2(params) {
        return axios.get('roaming/empowerment-v2/executor/count', {
            params
        })
    }

    printEmpowermentV2(id){
        return axios.get(`/pdf/roaming/empowerment-v2/${id}`,{
            responseType:'blob'
        })
    }


}

const roamingEmpowermentV2Service = new RoamingEmpowermentV2Service();

export default roamingEmpowermentV2Service;
